import React from 'react';

export default function CosmicBackground() {
  return (
    <div className="cosmic-bg">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-cosmos-bg via-cosmos-deep to-void" />
      
      {/* Static stars via CSS (no JS animation loop) */}
      <div className="cosmic-stars-layer absolute inset-0 opacity-80" />
      <div className="cosmic-stars-layer-2 absolute inset-0 opacity-60" />
      
      {/* Cosmic orbs - CSS animations (GPU-accelerated, no JS) */}
      <div
        className="cosmic-orb cosmic-orb-blue w-96 h-96 cosmic-float-slow"
        style={{ top: '10%', left: '20%' }}
      />
      
      <div
        className="cosmic-orb cosmic-orb-rose w-72 h-72 cosmic-float-medium"
        style={{ bottom: '20%', right: '15%' }}
      />
      
      <div
        className="cosmic-orb cosmic-orb-coherence w-64 h-64 cosmic-pulse"
        style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      />
    </div>
  );
}
